module.exports = __webpack_public_path__ + "img/uche.10cba213.png";